export const lowerCaseString = (s: any) => {
  if (typeof s !== "string") return "";
  return s.toLowerCase();
};

export const obscureEmail = (email: string) => {
  const [name, domain] = email.split("@");
  return `${name[0]}${new Array(name.length).join("*")}@${domain.substring(
    0,
    2
  )}${new Array(domain.length - 1).join("*")}`;
};

export const formatDeletedAccountEmail = (email: string) => {
  let formattedEmail: any = "";

  if (email) {
    const targetStr = email.substring(0, email.indexOf("@"));
    const mailDomain = email.substring(email.indexOf("@"), email.length);

    targetStr.split("").forEach((val: string, index: number) => {
      if (index === 0 || index === targetStr.length - 1) {
        formattedEmail = `${formattedEmail}${val}`;
      } else {
        formattedEmail = `${formattedEmail}*`;
      }
    });

    formattedEmail = `${formattedEmail}${mailDomain}`;
  }

  return formattedEmail;
};